import React, {useState} from 'react';
import {Box, styled, Tab, Tabs} from '@mui/material';
import PropTypes from 'prop-types';
import {toTestId} from '../utility/testIdUtil';

const BRAND_GREEN = '#0A8572';
const DARK_SUBTLE = '#355F54';

const PanelContainer = styled('div')(({theme}) => ({
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
}));

const TabsBar = styled(Tabs)({
    backgroundColor: '#fff',
    minHeight: 48,
});

const AdmicityTabs = ({
                          tabs,
                          variant = 'standard',
                          displayDivider = false,
                          onChange,
                          tabIndex,
                          slots = {
                              panel: {}
                          }
                      }) => {
    const [internalIndex, setInternalIndex] = useState(0);
    const controlled = typeof onChange === 'function';

    const handleTabChange = (_, newValue) => {
        controlled ? onChange(newValue) : setInternalIndex(newValue);
    };

    const activeIndex = controlled ? tabIndex : internalIndex;
    const safeActiveIndex = tabs[activeIndex] ? activeIndex : 0;
    const activeTab = tabs[safeActiveIndex];
    const activeColor = activeTab?.color || BRAND_GREEN;
    const ActivePanel = activeTab?.component ?? null;

    const tabsBar = (
        <TabsBar
            value={safeActiveIndex}
            onChange={handleTabChange}
            textColor="inherit"
            variant={variant}
            TabIndicatorProps={{
                style: {
                    backgroundColor: activeColor,
                    height: 3,
                    borderRadius: 2,
                },
            }}
        >
            {tabs.map(({
                           label,
                           color,
                           testId,
                           tabSx = {}
                       }, index) => {
                const selectedColor = color || BRAND_GREEN;

                return (
                    <Tab
                        key={label ?? index}
                        value={index}
                        label={label}
                        data-testid={testId ?? toTestId('tab', label ?? index)}
                        sx={{
                            color: DARK_SUBTLE,
                            opacity: 1,
                            fontWeight: 500,
                            minHeight: 48,
                            '&.Mui-selected': {
                                color: selectedColor,
                            },
                            ...tabSx,
                        }}
                    />
                );
            })}
        </TabsBar>
    );

    return (
        <>
            {displayDivider
                ? (
                    <Box sx={{
                        borderBottom: 1,
                        borderColor: 'divider'
                    }}>
                        {tabsBar}
                    </Box>
                )
                : (
                    tabsBar
                )}
            <PanelContainer sx={slots.panel}>{ActivePanel}</PanelContainer>
        </>
    );
};

AdmicityTabs.defaultProps = {
    tabs: [],
    variant: 'standard',
    displayDivider: false
};

AdmicityTabs.propTypes = {
    tabs: PropTypes.array,
    variant: PropTypes.string,
    displayDivider: PropTypes.bool,
    onChange: PropTypes.func,
    tabIndex: PropTypes.number,
    slots: PropTypes.object,
};

export default AdmicityTabs;
